export enum TAB {
  INSIGHT,
  QUESTIONS,
  EXPRESSIONS,
  MEDIA,
  INTRO,
  NOTE,
  QUESTION_SELECT,
  EXTERNAL,
  UPLOAD_FILE,
  UPLOAD_LINK,
  LESSON_STYLE,
  HOMEWORK,
  RELATED_CONTENTS,
}

export const STUDENT_MATERIAL_SUB_TAB_KEY_DICT = {
  [TAB.INSIGHT]: '인사이트',
  [TAB.QUESTIONS]: '수업 질문',
  [TAB.EXPRESSIONS]: '핵심 표현',
  [TAB.MEDIA]: '영상 / 기사',
  [TAB.RELATED_CONTENTS]: '링글 관련 콘텐츠',
} as const

export const enum PREP_TABS {
  QUESTION = '수업 질문',
  NOTE = '수업 노트',
  MY_ANSWER = '내 답변',
  OTHER_ANSWER = '다른 링글러 답변',
}
